import React from 'react';
import './Comment.css';

type CommentProps = {
  author: string;
  comment: string;
};

const Comment = ({ author, comment }: CommentProps) => {
  return (
    <div className='comment'>
      <p className='comment__author'>{author}</p>
      <p className='comment__text'>{comment}</p>
    </div>
  );
};

export default Comment;
